// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-module___wrapper___b37d1a25","carousel":"carousel-module___carousel___a7be85fd","itemContainer":"carousel-module___itemContainer___f41da6b5"};